module.exports = __webpack_public_path__ + "img/logo_orange.bed055c7.png";